import {defaultPropiedades, filtros, chartsDataDefault} from './state';
import {tarea} from './state';

/**
 * Establecer los filtros por defecto
 */
export function limpiarFiltros(state) {
    state.fechas= [],
    state.tarea= '',
    state.id_ubicacion= [],
    state.id_fabricante= null,
    state.id_producto= null,
    state.id_usuario_creacion= null,
    state.page= 1,
    state.per_page= 20,
    state.ids= []
    state.tareas = {
        data: []
    };
}


/**
 * Establecer tareas
 */
export function establecerTareas(state, tareas) {
    tareas.data.map(t => {
        t.seleccion = false;
    });
    state.tareas = tareas;
}

/**
 * Establecer tarea
 */
export function establecerTarea(state, tarea) {
    tarea.location_ids = tarea.locations.map(item=>item.id);
    state.tarea = tarea;
}

/**
 * Establecer tarea
 */
export function limpiarTarea(state) {
    state.tarea = tarea();
    state.componentes = [];
}

/**
 * Establecer empresas
 */
export function establecerEmpresas(state, empresas) {
    state.empresas = empresas;
}

/**
 * Establecer empresas
 */
export function establecerEmpresasFiltro(state, empresas) {
    state.empresas_filtro = empresas;
}

/**
 * Establecer ubicaciones
 */
export function establecerUbicaciones(state, ubicaciones) {
    state.ubicaciones = ubicaciones;
}

/**
 * Establecer ubicaciones
 */
export function establecerUbicacionesFiltro(state, ubicaciones_filtro) {
    state.ubicaciones_filtro = ubicaciones_filtro;
}

/**
 * Establecer fabricantes
 */
export function establecerFabricantes(state, fabricantes) {
    state.fabricantes = fabricantes;
}

/**
 * Establecer fabricantes_filtro
 */
export function establecerFabricantesFiltro(state, fabricantes) {
    state.fabricantes_filtro = fabricantes;
}

/**
 * Establecer categorías
 */
export function establecerCategorias(state, categorias) {

    let temp_categorias = [];

    if (categorias.fisicas && !!categorias.fisicas.length) {
        temp_categorias.push({
            id: 1,
            grupo: 'Fisicas',
            opciones: categorias.fisicas
        });
    }

    if (categorias.salud && !!categorias.salud.length) {
        temp_categorias.push({
            id: 2,
            grupo: 'Salud',
            opciones: categorias.salud
        });
    }

    if (categorias.ambientales && !!categorias.ambientales.length) {
        temp_categorias.push({
            id: 3,
            grupo: 'Ambientales',
            opciones: categorias.ambientales
        });
    }

    if (categorias.no_peligrosas && !!categorias.no_peligrosas.length) {
        temp_categorias.push({
            id: 4,
            grupo: 'No peligrosas',
            opciones: categorias.no_peligrosas
        });
    }

    state.categorias = temp_categorias;
}

export function establecerCategoriasSga(state, categorias) {
    let temp_categorias_sga = [];

    if (categorias.fisicas && !!categorias.fisicas.length) {

        categorias.fisicas.map(c_sga => {
            c_sga.producto = !!state.categorias[0] && !!state.categorias[0].opciones && !!state.categorias[0].opciones.find(c => c.id_categoria === c_sga.id);
        });

        temp_categorias_sga.push({
            id: 1,
            grupo: 'Fisicas',
            opciones: categorias.fisicas
        });
    }

    if (categorias.salud && !!categorias.salud.length) {

        categorias.salud.map(c_sga => {
            c_sga.producto = !!state.categorias[1] && !!state.categorias[1].opciones && !!state.categorias[1].opciones.find(c => c.id_categoria === c_sga.id);
        });

        temp_categorias_sga.push({
            id: 2,
            grupo: 'Salud',
            opciones: categorias.salud
        });
    }

    if (categorias.ambientales && !!categorias.ambientales.length) {

        categorias.ambientales.map(c_sga => {
            c_sga.producto = !!state.categorias[2] && !!state.categorias[2].opciones && !!state.categorias[2].opciones.find(c => c.id_categoria === c_sga.id);
        });

        temp_categorias_sga.push({
            id: 3,
            grupo: 'Ambientales',
            opciones: categorias.ambientales
        });
    }

    if (categorias.no_peligrosas && !!categorias.no_peligrosas.length) {

        categorias.no_peligrosas.map(c_sga => {
            c_sga.producto = !!state.categorias[3] && !!state.categorias[3].opciones && !!state.categorias[3].opciones.find(c => c.id_categoria === c_sga.id);
        });

        temp_categorias_sga.push({
            id: 4,
            grupo: 'No peligrosas',
            opciones: categorias.no_peligrosas
        });
    }

    state.categorias_sga = temp_categorias_sga;
}

/**
 * Establecer productos
 */
export function establecerProductos(state, productos) {
    state.productos = productos;
}

/**
 * Establecer productos
 */
export function establecerComponentes(state, componentes) {
    componentes.map(componente => {
        componente.select = componente.prod_component_id === state.tarea.id_componente;
    });
    state.componentes = componentes;
}

/**
 * Establecer productos
 */
export function establecerProductosFiltro(state, productos_filtro) {
    state.productos_filtro = productos_filtro;
}

/**
 * Establecer usuarios
 */
export function establecerUsuarios(state, usuarios) {
    state.usuarios = usuarios;
}

/**
 * Establecer cargos
 */
export function establecerCargos(state, cargos) {
    state.cargos = cargos;
}

/**
 * Establecer ges
 */
export function establecerGes(state, ges) {
    state.ges = ges;
}

/**
 * Establecer accion
 */
export function establecerAccion(state, accion) {
    state.accion = accion;
}

/**
 * Establecer id_ubicacion
 */
export function establecerIdUbicacion(state, id_ubicacion) {
    state.tarea.id_ubicacion = id_ubicacion;
}

/**
 * Establecer id_componente
 */
export function establecerIdComponente(state, id_componente) {
    state.tarea.id_componente = id_componente;
}

/**
 * Establecer id_categoria
 */
export function establecerIdCategoria(state, id_categoria) {
    state.tarea.id_categoria = id_categoria;
}

/**
 * Establecer id_ubicacion_filtro
 */
export function establecerIdUbicacionFiltro(state, id_ubicacion_filtro) {
    state.filtros.id_ubicacion = id_ubicacion_filtro;
}

/**
 * Establecer id_producto_filtro
 */
export function establecerIdProductoFiltro(state, id_producto_filtro) {
    state.filtros.id_producto = id_producto_filtro;
}

/**
 * Establecer id_producto
 */
export function establecerIdProducto(state, id_producto) {
    state.tarea.id_producto = id_producto;
}

/**
 * Función para paginar analisis
 *
 * @param {*} state
 */
export function setPerPageAnalysis(state, perPage) {
    state.filtros.page = 1;
    state.filtros.per_page = perPage
}

/**
 * Función para paginar analisis
 *
 * @param {*} state
 */
export function setPageAnalysis(state, page) {
    state.filtros.page = page;
}

/**
 * Establecer id_producto
 */
export function establecerIdCargo(state, id_cargo) {
    state.tarea.id_cargo = id_cargo;
}

/**
 * Establecer id_ges
 */
export function establecerIdGes(state, id_ges) {
    state.tarea.id_ges = id_ges;
}

/**
 * Establecer tlv
 */
export function establecerTlv(state, tlv) {
    state.tarea.tlv = tlv;
}

/**
 * Establecer id_unidad_medida_tlv
 */
export function establecerIdUnidadMedidaTlv(state, id_unidad_medida_tlv) {
    state.tarea.id_unidad_medida_tlv = id_unidad_medida_tlv;
}

/**
 * Establecer cargando_datos_select
 */
export function establecerCargandoDatosSelect(state, cargando_datos_select) {
    state.cargando_datos_select = cargando_datos_select;
}

/**
 * Establecer unidades de temperatura
 */
export function establecerUnidadesDeTemperatura(state, unidades_de_temperatura) {
    state.unidades_de_temperatura = unidades_de_temperatura;
}

/**
 * Establecer capacidades
 */
export function establecerCapacidades(state, capacidades) {
    state.capacidades = capacidades;
}

/**
 * Establecer opciones_frecuencia_1
 */
export function establecerOpcionesDeFrecuencia1(state, opciones_frecuencia_1) {
    state.opciones_frecuencia_1 = opciones_frecuencia_1;
}

/**
 * Establecer opciones_frecuencia_2
 */
export function establecerOpcionesDeFrecuencia2(state, opciones_frecuencia_2) {
    state.opciones_frecuencia_2 = opciones_frecuencia_2;
}

/**
 * Establecer vias_ingreso
 */
export function establecerViasDeIngreso(state, vias_ingreso) {
    state.vias_ingreso = vias_ingreso;
}

/**
 * Establecer opciones_superficies_expuestas
 */
export function establecerSuperficiesExpuestas(state, opciones_superficies_expuestas) {
    state.opciones_superficies_expuestas = opciones_superficies_expuestas;
}


/**
 * Establecer clases_de_procedimiento
 */
export function establecerClasesDeProcedimiento(state, clases_de_procedimiento) {
    state.clases_de_procedimiento = clases_de_procedimiento;
}

/**
 * Establecer clases_de_pulverulencia
 */
export function establecerClasesDePulverulencia(state, clases_de_pulverulencia) {
    state.clases_de_pulverulencia = clases_de_pulverulencia;
}

/**
 * Establecer unidades_de_medida_tlv
 */
export function establecerUnidadesDeMedidaTlv(state, unidades_de_medida_tlv) {
    state.unidades_de_medida_tlv = unidades_de_medida_tlv;
}

/**
 * Establecer clase de pulverulencia
 */
export function establecerClaseDePulverulencia(state, id_producto) {
    const clase_pulverulencia = state.clases_de_pulverulencia.find(cp => cp.codigo === 'CPUL04');

    if (clase_pulverulencia) {
        state.tarea.id_clase_pulverulencia = clase_pulverulencia.id;
    }
}

/**
 * Establecer resultado
 */
export function establecerResultado(state, resultado) {
    state.resultado = resultado;
}

/**
 * Establecer modal.ver
 */
export function establecerModalVer(state, ver) {
    state.modal.ver = ver;
}

/**
 * Establecer modal_propiedades.ver
 */
export function establecerModalPropiedadesVer(state, ver) {
    state.modal_propiedades.ver = ver;
}

/**
 * Establecer id empresa filtro
 */
export function establecerIdEmpresaFiltro(state, id_empresa) {
    state.filtros.id_empresa = id_empresa;
}


/**
 * Establecer id empresa tarea
 */
export function establecerIdEmpresaTarea(state, id_empresa) {
    state.tarea.id_empresa = id_empresa;
}

/**
 * Establecer las propiedades de un producto
 * @param propiedades Contiene las propiedades
 */
export function establecerPropiedades(state, propiedades) {
    state.propiedades = propiedades;
}

/**
 * Establecer el id del producto
 * @param id_producto Contiene el id del producto
 */
export function establecerIdProductoEnPropiedades(state, id_producto) {
    state.propiedades.id_producto = id_producto;
}

/**
 * Limpiar las propiedades de un producto
 */
export function setDefaultPropiedades(state) {
    Object.assign(state.propiedades, defaultPropiedades());
}

/**
 * Limpiar las propiedades de un producto
 */
export function setIdsFiltro(state) {

    let ids = [];

    state.filtros.ids = [];

    state.tareas.data.map(t => {
        if (t.seleccion) {
            ids.push(t.id);
        }
    });

    state.filtros.ids = ids;
}

/**
 * Establecer ver modal de attacments.
 * @param view
 */
export function setModalAttachments(state, view) {
    state.modal_attachments.view = view;
}

/**
 * Establecer producto seleccionado.
 * @param producto
 *
 * @return void
 */
export function setProductSelected(state, product) {
    state.product_selected = product;
}

/**
 * Establecer informacion para los graficos.
 * @param producto
 *
 * @return void
 */
export function setInfoCharts(state, data) {
    state.charts_data.tasks = data.tasks;
    state.charts_data.levels = data.levels;
    state.charts_data.quantity = data.quantity;
    state.charts_data.level_info = data.level_info;
}

/**
 * Establecer informacion para los graficos de los estados del nivel.
 * @param status
 * @return void
 */
export function setStatusInfo(state, status) {
    state.charts_data.status_info = status;
}

/**
 * Establecer el color primario para los graficos
 * @param color
 * @return void
 */
export function setPrimaryColorCharts(state, val) {
    if (val == 1) {
        state.charts_data.color = '#EF5350'
    } else if (val == 2) {
        state.charts_data.color = '#FFEE58'
    } else if (val == 3) {
        state.charts_data.color = '#66BB6A'
    }
}

/**
 * Establecer los filtros por defecto.
 */
export function clearFilters(state) {
    state.filtros = filtros();
    state.charts_data = chartsDataDefault();
}


/**
 * Establecer informacion para los graficos de los cargos por nivel.
 * @param status
 * @return void
 */
export function setChargesInfo(state, charges) {
    state.charts_data.charges_info = charges;
}


/**
 * Establecer informacion para los graficos de los cargos por nivel.
 * @param status
 * @return void
 */
export function setComponentsInfo(state, components) {
    state.charts_data.components_info = components;
}


/**
 * Establecer informacion el total de trabajadores expuestos por nivel
 * @param status
 * @return void
 */
export function setExposedWorkers(state, data) {
    state.charts_data.exposed_workers = data;
}



/**
 * Establecer informacion para los graficos de los cargos por nivel.
 * @param status
 * @return void
 */
export function setAreasInfo(state, areas_info) {
    state.charts_data.areas_info = areas_info;
}


/**
 * Establecer informacion para los graficos de los cargos por nivel.
 * @param status
 * @return void
 */
export function setRouteOfEntryInfo(state, route_of_entry_info) {
    state.charts_data.route_of_entry_info = route_of_entry_info;
}

/**
 * Establecer un valor para la variable tasks.
 */
export function setTasks(state, tasks) {
    state.tasks = tasks;
}

/**
 * Establecer un valor para la variable positions.
 */
export function setPositions(state, positions) {
    state.positions = positions;
}

/**
 * Establecer un valor para la variable hygienic_measurements.
 */
export function setHygienicMeasurements(state, hygienic_measurements) {
    state.hygienic_measurements = hygienic_measurements;
}

/**
 * Establecer un valor por defecto pala la variable hygienic_measurements.
 */
export function addDefaultHygienicMeasurements(state) {
    state.hygienic_measurements.push({id:null,name: 'NO REGISTRA', Description:'NO REGISTRA'});
}

/**
 * Establecer un valor para la variable workers.
 */
export function setWorkers(state, workers) {
    state.workers = workers;
}

/**
 * Establecer un valor para la variable controls.
 */
export function setControls(state, controls) {
    state.controls = controls;
}

/**
 * Setear producto recien creado.
 */
export function setProductId(state, id) {
    state.tarea.id_producto = id;
}
